

































import Vue from "vue";
import StuntSheetDot from "@/models/StuntSheetDot";

/**
 * Renders the pending dots generated from the tool in use.
 */
export default Vue.extend({
  name: "GrapherTool",
  computed: {
    grapherToolDots(): StuntSheetDot[] {
      return this.$store.state.grapherToolDots;
    },
    showDotLabels(): boolean {
      return this.$store.state.showDotLabels;
    },
    grapherToolDotLabels(): [StuntSheetDot, string][] {
      const dotLabels = this.$store.getters.getDotLabels;
      const dots: StuntSheetDot[] = this.grapherToolDots;
      return dots.map((dot) => {
        return [
          dot,
          dotLabels !== null &&
          dot.dotLabelIndex !== null &&
          dot.dotLabelIndex < dotLabels.length
            ? dotLabels[dot.dotLabelIndex]
            : "",
        ];
      });
    },
    showSelectionLasso(): boolean {
      return this.$store.state.showSelectionLasso;
    },
    selectionLasso(): string {
      // construct a string ready to be used by polyline.  See:
      // https://developer.mozilla.org/en-US/docs/Web/SVG/Element/polyline
      const lassoPointStrings: string[] = this.$store.state.selectionLasso.map(
        (point: [number, number]) => point.join(",")
      );
      return lassoPointStrings.join(" ");
    },
  },
});
